import { render, staticRenderFns } from "./CreateView.vue?vue&type=template&id=2fe0b428"
import script from "./CreateView.vue?vue&type=script&lang=js"
export * from "./CreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports